// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Software Risk Management admin config view.
 *
 * Phase 1: Minimal placeholder.
 */
import type { FC } from 'react'
import type { NodeAdminViewProps } from '@/core/types'

export const SrmAdminView: FC<NodeAdminViewProps> = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold">SRM Configuration</h1>
      <p className="text-muted-foreground mt-2">
        Configuration coming soon.
      </p>
    </div>
  )
}
